import React, { useEffect, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { hasSubscriptions } from '../client/utils/index.js';

import '../client/scss/index.scss';

const Assistant = (props) => {
  const { moduleId, User, i18n } = props;
  const [resource, setResource] = useState(null);

  useEffect(() => {
    import(`@betwixt/common/modules/assistant/translation/${i18n.language}.json`)
      .then((module) => setResource(module.default || module))
      .catch(() => setResource(null));
  }, [i18n.language]);

  if (!resource) return null;

  const _hasSubscriptions_ = hasSubscriptions(User);

  const _t = resource;

  if (moduleId === 'shop' && !_hasSubscriptions_)
    return (
      <div id="Assistant">
        <div className="box-assistant first_subscribe">
          <FontAwesomeIcon icon={faStar} className="fa-1x" />
          <h4>{_t.first_subscribe.title}</h4>
          <p>{_t.first_subscribe.description}</p>
        </div>
      </div>
    );

  return null;
};

export default Assistant;
